import { createFileRoute, redirect, useParams } from "@tanstack/react-router";
import { AutomationsPage } from "./automations/-automationsPage/AutomationsPage";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { queryClient, trpc } from "~/utils/trpc";
import { hasPermission } from "~/store/usePermissionStore";

export const Route = createFileRoute("/_dashboard/$datasetSlug/automations/")({
  beforeLoad: async ({ params }) => {
    const session = await queryClient.fetchQuery(trpc.auth.getSession.queryOptions()).catch(() => null);

    if (!hasPermission({ role: session?.user?.role, permissions: session?.user?.permissions }, "automations", "view")) {
      throw redirect({ to: "/$datasetSlug/dashboard", params: { datasetSlug: params.datasetSlug } });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });
  useBreadCrumbs([{ title: "Automations", link: `/${datasetSlug}/automations` }]);
  return <AutomationsPage />;
}
